export default "__VITE_ASSET__CnGj$5WG__"